var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"secondary",attrs:{"app":"","fixed":"","clipped-left":""}},[_c('span',{staticClass:"caption white--text mx-3"},[_vm._v("© 2020 - The WBS Team")])])}
var staticRenderFns = []

export { render, staticRenderFns }